import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import BoxItem from 'common/oldJavascripts/components/Base/Box/BoxItem';
import Link from 'common/oldJavascripts/components/Base/Link';
import Modal from 'common/oldJavascripts/components/Base/Modal';
import Separator from 'common/oldJavascripts/components/Base/Separator';
import Text from 'common/oldJavascripts/components/Base/Text';

const styles = {
  linkContainer: {
    alignItems: 'center',
    display: 'flex',
    padding: '20px',
    width: '100%',
    justifyContent: 'space-around',
  },
};

const RescindErrorModal = props => {
  const { onClose, classes } = props;
  return (
    <Modal>
      <BoxItem>
        <Text alert={true} big={true}>
          Offer has been Rescinded. Contact your manager for more information.
        </Text>
      </BoxItem>
      <Separator />

      <BoxItem nopadding={true}>
        <div className={classes.linkContainer}>
          <Link onClick={onClose}>Close</Link>
        </div>
      </BoxItem>
    </Modal>
  );
};

export default withStyles(styles)(RescindErrorModal);
